import ReactOnRails from 'react-on-rails';

import BackButton from '@components/application/backButton';
import CashPrice from '@components/application/pricing/cashPrice';
import EnquiryForm from '@components/enquiries/enquiryForm';
import Saving from '@components/application/pricing/saving';

ReactOnRails.register({
  BackButton,
  CashPrice,
  EnquiryForm,
  Saving,
});
